module.exports = __webpack_public_path__ + "static/media/GoudyNational-Italic.2d1f63d7.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GoudyNational-Italic.eot
// module id = 3196
// module chunks = 68